"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class VizLoadErrorEvent {
    constructor(errorCode, message) {
        this._errorCode = errorCode;
        this._message = message;
    }
    get message() {
        return this._message;
    }
    get errorCode() {
        return this._errorCode;
    }
}
exports.VizLoadErrorEvent = VizLoadErrorEvent;
//# sourceMappingURL=VizLoadErrorEvent.js.map